import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { AskAiResult, AskAiService } from './ask-ai.service';

@Injectable({ providedIn: 'root' })
export class AskAiMockService implements AskAiService {
  ask(_question: string, _patientId?: string | null): Observable<AskAiResult> {
    return of({
      id: 'mock-ask-ai-id',
      question: _question,
      patientId: _patientId ?? null,
      status: 'Completed',
      patientContextAvailable: !!_patientId,
      answerText:
        '<p>This is a <strong>mock AI response</strong>. The service is running in mock mode.</p>',
      disclaimer:
        'AI insights are educational and for clinician review only. Not diagnostic or prescriptive.',
      errorMessage: null,
      createdAtUtc: new Date().toISOString(),
      completedAtUtc: new Date().toISOString(),
      failedAtUtc: null,
    } as AskAiResult).pipe(delay(1500));
  }

  getPdf(_id: string): Observable<Blob> {
    return of(new Blob(['Mock PDF content'], { type: 'application/pdf' }));
  }
}
